import { PhoneField } from '@hypeit-gmbh/hypeit-ui';
import { Grid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { DEFAULT_SPAN, TRANS_KEY, useContactPrefix } from '../Root';

type MobilePropsType = {
  span?: number;
};

export const Mobile: React.FC<MobilePropsType> = ({ span }) => {
  const { t } = useTranslation();
  const prefix = useContactPrefix();

  return (
    <Grid.Col span={span ?? DEFAULT_SPAN}>
      <PhoneField
        fieldName={`${prefix}.mobile`}
        label={t(`${TRANS_KEY}.MOBILE_LABEL`)}
      />
    </Grid.Col>
  );
};
